"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageHeader_1 = require("./PageHeader");
exports.default = PageHeader_1.default;
//# sourceMappingURL=index.js.map